export const VOICE_LOUDNESS_COLORS = Object.freeze({
  TOO_LOW: '#D4D7DD',
  TARGET: '#7ED321',
  TOO_LOUD: '#FF5050',
  TEXT: '#4A6A84',
  NEEDLE: '#0D1B2A',
});